var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 6.91067V14.1167H21.096V6.8232C21.096 4.49549 19.5917 2.76029 17.2549 2.76029C14.9182 2.76029 13.4139 4.49549 13.4139 6.8232V14.1195H10.5607V6.8232C10.5607 4.49549 9.05644 2.76029 6.71966 2.76029C5.48354 2.70104 4.30668 3.27944 3.60113 4.29517C3.11007 5.03721 2.85607 5.91187 2.87582 6.80345V14.1167H0V1.13794C0.519285 1.50473 0.97366 1.95335 1.35183 2.46403L1.39699 2.52611C2.67827 0.900939 4.64534 -0.0329678 6.71684 0.000889879C7.80339 -0.00475306 8.87018 0.271751 9.81562 0.802187C10.7215 1.31287 11.4694 2.06056 11.9831 2.96908C13.0555 1.09562 15.0762 -0.0329677 17.2324 0.0403905C21.2314 0.0347476 24 3.02268 24 6.91067Z",
    fill: "#044D66"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMri);
export default __webpack_public_path__ + "static/media/MRI.9758090a9c12aa497388c04298925663.svg";
export { ForwardRef as ReactComponent };